import React from 'react';
import styled from 'styled-components';
import { maxWidth, primaryColor, retina } from 'Utils/utilsStyle';

type Props = {
  color?: string;
  height?: string;
  width?: string;
  className?: string;
} & typeof defaultProps;

const defaultProps = {
  color: `${primaryColor}`,
  height: '12px',
  width: '13px',
  className: '',
};

const SVG = styled.svg`
  @media all and (max-width: ${maxWidth}) , ${retina} {
    width: 13px;
    min-width: 13px;
    height: 12px;
  }
`;

const CompanyCompareIcon = function CompanyCompareIcon({
  color, height, width, className,
}: Props) {
  return (

    <SVG width={width} height={height} viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.51539 0.251939C9.19669 -0.0839798 8.68009 -0.0839798 8.36151 0.251939C8.04281 0.587858 8.04281 1.13243 8.36151 1.46833L10.2305 3.42977H0.812614C0.363868 3.42977 1.79154e-05 3.81332 1.79154e-05 4.28628C1.79154e-05 4.75938 0.363868 5.14293 0.812614 5.14293H12.1888C12.5169 5.1412 12.8118 4.9317 12.9364 4.61185C13.0637 4.29287 12.9964 3.92451 12.7658 3.67814L9.51539 0.251939ZM12.1874 6.85718H0.811186C0.483101 6.8589 0.188193 7.0684 0.0636017 7.3881C-0.0637129 7.70709 0.00361484 8.0753 0.234172 8.32153L3.48456 11.7467C3.63717 11.9089 3.84489 12 4.06155 12C4.27821 12 4.48581 11.9089 4.6384 11.7467C4.79224 11.586 4.87875 11.367 4.87875 11.1387C4.87875 10.9104 4.79224 10.6916 4.6384 10.5307L2.76946 8.56975H12.1873C12.636 8.56975 12.9999 8.18646 12.9999 7.7135C12.9999 7.24054 12.636 6.85714 12.1873 6.85714L12.1874 6.85718Z" fill={color} />
    </SVG>
  );
};

CompanyCompareIcon.defaultProps = defaultProps;
export default CompanyCompareIcon;
